import {v4 as uuidv4} from "uuid";
import {faker} from "@faker-js/faker";
import { getAccounts } from "../helpers/get-accounts";

var regionCodes = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ap-south-1",
];

export const getActivationCode = async() => {
  let accounts = await getAccounts();
  var activationDetails = {
    AccountNumber: faker.helpers.arrayElement(accounts),
    ActivationCode: "ZMN+XVlmlXFnAZIdZQKX",
    ActivationId: uuidv4(),
    CreatedAt: "2020-09-16 20:37:43",
    DefaultInstanceName: null,
    Description: null,
    ExpirationDate: "2020-10-13 02:07:32",
    Expired: false,
    IAMRoleName: "MontyCloud-HybridActivationRole",
    ID: faker.random.alphaNumeric(15),
    Region: faker.helpers.arrayElement(regionCodes),
    RegistrationLimit: faker.number.int({ min: 0, max: 1000 }),
    RegistrationsCount: faker.number.int({ min: 0, max: 10 }),
    Tags: [],
  };
  return activationDetails;
};

export const getActivationRoleDetails = () => {
  return {
    CFNUrl:
      "https://mc-dev1-blueprints-permissions.s3.amazonaws.com/HybridActivation/MontyCloud-HybridActivationRole.yaml",
    ResourceName: "MontyCloud-HybridActivationRole",
    ResourceType: "IAMRole",
  };
};
